import classNames from 'classnames';
import React, { useCallback, useState } from 'react';

import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../../styles/modals/help-modal.module.scss';

interface HelpModalProps {
    onClose?: () => void;
    className?: string;
    contentClassName?: string;
    closeButtonClassName?: string;
    withCloseButton?: boolean;
    children?: React.ReactNode;
}

function HelpModal({
    onClose = null,
    withCloseButton = true,
    children = null,
    className = null,
    contentClassName = null,
    closeButtonClassName = null,
}: HelpModalProps) {
    const [opened, setOpened] = useState(true);

    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    return (
        <Modal withSafe opened={opened} onClosed={onClose}>
            <Dialog
                className={classNames([styles.dialog, className])}
                contentClassName={classNames([styles.content, contentClassName])}
                closeButtonClassName={classNames([styles.closeButton, closeButtonClassName])}
                withCloseButton={withCloseButton}
                onClickClose={onRequestClose}
            >
                {children}
            </Dialog>
        </Modal>
    );
}

export default HelpModal;
